import { Component, Signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { select } from '@ngxs/store';
import { AuthUser } from 'src/app/auth/models/auth-user.model';
import { UserState } from 'src/app/auth/store';
import { UserRoleEnum } from 'src/app/shared/enums/UserRoleEnum';

@Component({
  selector: 'app-user-info',
  imports: [RouterLink],
  templateUrl: './user-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-info.component.scss'
})
export class UserInfoComponent {
  protected user: Signal<AuthUser> = select(UserState.loggedUser);
  protected userRole: Signal<UserRoleEnum> = select(UserState.role);
  protected UserRoleEnum = UserRoleEnum;
}
